export default {
  COMMON: {
    REJECT: 'Avvisa',
    CONTINUE: 'Fortsätt',
    SIGN: 'Signera',
    LOADING: 'Laddar...',
    VERIFY: 'Verifiera',
    CANCEL: 'Avbryt',
    VIEW: 'Visa',
    DOWNLOAD: 'Ladda ner',
    ATTACHMENTS: 'Bilagor',
    DOCUMENTS: 'Dokument',
    READ: 'Läst',
    CHECKED: 'Kontrollerad',
  },

  APPROVER_INBOX: {
    TITLE: 'Orderinkorg',
    SUBTITLE: 'Välj de order du vill signera.',
    SELECT_ALL: 'Markera alla order',
    SELECT_ALL_ORDERS: 'Markera alla order',
    LOADING: 'Laddar inkorg...',
    EMPTY: 'Inga order hittades.',
    EMPTY_TITLE: 'Inga underskriftsordrar för godkännande',
    EMPTY_SUBTITLE: 'Det finns för tillfället inga underskriftsordrar som väntar på ditt godkännande.',
    ERROR_LOAD: 'Kunde inte ladda inkorgen.',
    UNKNOWN_SENDER: 'Okänd avsändare',
    SENT_YOU_FILES: 'skickade dokument till dig för signering',
    VIEW_FILE: 'Visa fil',
    REJECT_ORDER: 'Avvisa order',
    REVIEW_SELECTED: 'Granska valda ({{count}})',
    EXPAND: 'Expandera',
    COLLAPSE: 'Fäll ihop',
    CREATED: 'Skapad',
    ONE_FILE: '1 fil',
    MANY_FILES: 'dokument',
    MORE: 'Fler',
    COPY_HASHSUM: 'Kopiera hashsumma',
  },
  APPROVER_SIGN: {
    TITLE: 'Avtalsdokument för signering',
    INSTRUCTION: 'Jag har läst och godkänner innehållet i följande avtalsdokument. När jag har undertecknat avtalen är de bindande för mig.',
  },
  TAB_DETECTION: {
    TITLE: 'Denna URL-länk används redan i en annan flik.',
    SUBTITLE: 'Stäng den andra fliken och läs sedan in den här sidan igen.',
  },

  FORMS: {
    NO_COUNTRIES_FOUND: 'Inga länder hittades',
    NO_RESULTS_FOUND: 'Inga resultat hittades',
    CHOOSE_FILES: 'Välj filer',
    NO_FILE_CHOSEN: 'Ingen fil vald',
    SELECT_AN_OPTION: 'Välj ett alternativ',
    SEARCH: 'Sök...',
    ERRORS: {
      REQUIRED: 'Detta fält är obligatoriskt',
      EMAIL: 'Vänligen ange en giltig e-postadress',
      MIN_LENGTH: 'Minsta längd är {{requiredLength}} tecken',
      MAX_LENGTH: 'Maximal längd är {{requiredLength}} tecken',
      INVALID: 'Ogiltigt värde',
      ONLY_NUMBERS: 'Endast siffror är tillåtna',
      FILE_TYPE: 'Filen måste vara jpeg, jpg, bmp, gif eller pdf',
      CPR_ONLY_DIGITS: 'CPR får bara innehålla siffror',
      CPR_LENGTH: 'CPR måste vara exakt 10 siffror',
      CPR_INVALID: 'CPR-numret är inte giltigt',
      BANK_ACCOUNT_REG_ONLY_NUMERIC: 'Endast siffror är tillåtna',
      BANK_ACCOUNT_REG_FOUR_DIGITS: 'Registreringsnumret måste vara exakt 4 siffror',
      CVR_ONLY_NUMERIC: 'Endast siffror är tillåtna',
      CVR_EIGHT_DIGITS: 'CVR måste vara exakt 8 siffror',
    },
  },

  CALENDAR: {
    DAYS: {
      SUN: 'Sön',
      MON: 'Mån',
      TUE: 'Tis',
      WED: 'Ons',
      THU: 'Tor',
      FRI: 'Fre',
      SAT: 'Lör',
    },
    MONTHS: {
      JANUARY: 'Januari',
      FEBRUARY: 'Februari',
      MARCH: 'Mars',
      APRIL: 'April',
      MAY: 'Maj',
      JUNE: 'Juni',
      JULY: 'Juli',
      AUGUST: 'Augusti',
      SEPTEMBER: 'September',
      OCTOBER: 'Oktober',
      NOVEMBER: 'November',
      DECEMBER: 'December',
    },
  },

  SIGNATURE: {
    CLEAR_SIGNATURE: 'Rensa Signatur',
    YOUR_SIGNATURE: 'Din Signatur',
    AGREEMENT_DOCUMENT_TITLE: 'Avtalsdokument för underskrift',
    AGREEMENT_DOCUMENT_DESCRIPTION: 'Genom att skriva under avtalet anger jag att jag har läst och godkänt innehållet i följande avtalsdokument. Min underskrift är bindande.',
    FORM_DESCRIPTION: 'Genom att skriva under formuläret anger jag att jag har läst och godkänt innehållet i följande formulär. Min underskrift är bindande.',
    SIGN_HERE: 'Skriv under här',
  },

  STEPS: {
    LOGIN_SHARED_SECRET: 'Logga in med överenskommen kod',
    LOGIN_OTP: 'Logga in med OTP',
    LOGIN_EID: 'Logga in med eID',
    LOGIN_MITID: 'Logga in med MitID',
    REVIEW_FILES: 'Granska filer',
    REVIEW_DOCUMENTS: 'Läs dokument',
    REVIEW_FORMS: 'Läs formulär',
    ORDER_QUESTIONS: 'Besvara frågor',
    SIGN: 'Signera dokument',
    SIGN_FORM: 'Formulär för signering',
    RECEIPT: 'Kvitto',
    DOWNLOAD: 'Ladda ner',
    CPR: 'CPR-verifiering',
    FILE: 'Filuppladdning',
    FILES: 'Säker ePost',
    APPROVER_REVIEW_FILES: 'Orderinkorg',
    APPROVER_SIGN: 'Avtalsdokument för signering',
  },
  LOGIN_OTP: {
    INSTRUCTION: 'Vänligen ange SMS-koden du har mottagit på din mobil. Koden har skickats till telefonnr. {{ phoneNumber }}.',
    OTP_CODE: 'OTP Kode',
    OTP_EXPIRED: 'Engångskoden har gått ut. Vänligen begär en ny.',
    RESEND_OTP: 'Skicka OTP igen',
    RESEND_OTP_IN: 'Skicka OTP igen om',
    OTP_PHONE_INSTRUCTION: 'Vänligen ange den 6-siffriga koden som skickats till din telefon.',
  },
  LOGIN_SHARED_SECRET: {
    INSTRUCTION: 'För att verifiera din identitet och få åtkomst till dina dokument, vänligen ange den överenskomna koden som du har fått från {{ senderName }}.',
    SHARED_SECRET: 'Överenskommen kod',
    SHARED_SECRET_ERROR: 'Den överenskomna koden stämmer inte',
    SHARED_SECRET_REQRUIRED: 'Den överenskomna koden krävs',
  },

  LOGIN_EID: {
    POPUP_ALERT: 'Vänligen inaktivera din popup-blockerare och försök igen.',
    ORIGIN_MISMATCH: 'Säkerhetsvarning: Identitetsleverantörens ursprung matchar inte. Försök igen.',
    SUCCESS: 'Du har loggat in.',
    AUTHENTICATED: 'Autentiseringen lyckades.',
    ERROR: 'Inloggningen misslyckades. Försök igen.',
    INSTRUCTION: 'För att säkert få åtkomst till att signera dina dokument, vänligen logga in med din eID. Välj en inloggningsmetod nedan för att fortsätta.',
    SINGLE_PROVIDER_INSTRUCTION: 'För att få säker åtkomst till att signera dina dokument ska du logga in för att fortsätta.',
    FORM_INSTRUCTION: 'För att säkert få åtkomst till att signera ditt formulär, vänligen logga in med din eID. Välj en inloggningsmetod nedan för att fortsätta.',
    FORM_SINGLE_PROVIDER_INSTRUCTION: 'För att få säker åtkomst till att signera ditt formulär ska du logga in för att fortsätta.',
    CPR_INSTRUCTION: 'Logga in med ditt MitID/eID för att bekräfta din identitet. Välj en inloggningsmetod nedan för att fortsätta.',
    CPR_SINGLE_PROVIDER_INSTRUCTION: 'Logga in med ditt MitID/eID för att bekräfta din identitet.',
    PROVIDERS: {
      mitid: 'Logga in med MitID',
      'mitid-business': 'Logga in med MitID Företag',
      bankid_no: 'Logga in med norskt BankID',
      swedish_bank_id: 'Logga in med Svenskt BankID',
      default: 'Logga in med {{name}}',
    },
    MITID_BUSINESS_SUBTITLE: 'Kan användas om ditt företag/förening har anslutit sig till MitID Företag',
  },

  REVIEW_FILES: {
    INSTRUCTION: 'Vänligen hämta eller öppna alla bilagor.\nNär allt har hämtats eller öppnats kommer avsändaren att få ett meddelande om detta\nNär alla bilagor har hämtats eller öppnats kan du gå vidare till ditt kvitto',
    SHOW_ALL_SIGNERS: 'Status för undertecknare',
    ATTACHMENTS: 'Bilagor',
    DESCRIPTION: 'Se vilka personer som har signerat och vilka som saknas.',
    NO_SIGNERS_FOUND: 'Inga undertecknare hittades',
    FILES_LEFT: 'Du behöver läsa de återstående {{count}}, dokument(en).',
    FILES_READ_ALL: 'Du har läst alla dokumenten. Du kan nu gå vidare till signaturen.',
    FORM_FILES_LEFT: 'Du behöver läsa de återstående {{count}} formulär(en).',
    FORM_FILES_READ_ALL: 'Du har läst alla formulären. Du kan nu gå vidare till signaturen.',
    GO_TO_RECEIPT: 'Gå till kvitto',
    CONTINUE: 'Fortsätt',
    FILES: 'Dokument',
  },

  REVIEW_DOCUMENTS: {
    INSTRUCTION: 'Vänligen öppna och läs alla dokument och eventuella bilagor nedan.',
    FORM_INSTRUCTION: 'Vänligen öppna och läs alla formulär och eventuella bilagor nedan.',
    FILES: 'Dokument',
    FORM_FILES_ONE: 'Formulär',
    FORM_FILES_MANY: 'Formulär',
    SHOW_ALL_SIGNERS: 'Status för undertecknare',
    ATTACHMENTS: 'Bilagor',
    DESCRIPTION: 'Se vilka personer som har signerat och vilka som saknas.',
    NO_SIGNERS_FOUND: 'Inga undertecknare hittades',
  },

  SIGN_DOCUMENT: {
    INSTRUCTION: 'Vänligen öppna och läs alla dokument och eventuella bilagor nedan.',
  },

  ORDER_QUESTIONS: {
    INSTRUCTION: 'Vänligen fyll i fälten nedan.',
    LOADING: 'Laddar frågor...',
    SAVING: 'Sparar...',
    REQUIRED_FIELDS_WARNING: 'obligatoriska frågor är inte besvarade',
    GOTO_FIRST_UNANSWERED: 'Gå till första',
    INPUTS_NOT_EQUAL: 'Det du har skrivit in är inte lika',
    ENTER_FIELD_PLACEHOLDER: 'Ange {{field}}',
    ENTER_ZIP_CODE_PLACEHOLDER: 'Ange postnummer',
    ENTER_EMAIL_PLACEHOLDER: 'Ange e-postadress',
    ENTER_VALUE_PLACEHOLDER: 'Ange värde',
    YES: 'Ja',
    NO: 'Nej',
    ERRORS: {
      REQUIRED: 'Detta fält är obligatoriskt.',
      EMAIL: 'Ange en giltig e-postadress.',
      CPR: 'Ange ett giltigt CPR-nummer.',
      CVR_ONLY_NUMERIC: 'Endast siffror är tillåtna.',
      CVR_EIGHT_DIGITS: 'CVR måste vara exakt 8 siffror.',
      BANK_REGISTRATION_NUMBER_ONLY_NUMERIC: 'Endast siffror är tillåtna.',
      BANK_REGISTRATION_NUMBER_FOUR_DIGITS: 'Registreringsnummer måste vara exakt 4 siffror.',
      PATTERN: 'Ogiltigt format.',
      VALUE_NOT_ALLOWED: 'Detta värde kan inte användas. Ange ett annat.',
      BACKEND_INVALID: 'Värdet kunde inte sparas. Försök igen.',
      FILE_TYPE: 'Denna filtyp är inte tillåten.',
      INVALID: 'Ogiltigt värde.',
    },
  },

  RECEIPT: {
    SUCCESS_HEADING: 'Din signatur har slutförts',
    FILES_ORDER_SUCCESS_HEADING: 'Dina filer är hämtade',
    FILES_ORDER_SUCCESS_MESSAGE: 'Ett e-postmeddelande har skickats till',
    SUCCESS_MESSAGE: 'Vi har skickat ett kvitto för din signatur till',
    SUCCESS_COMPLETION: 'Först när alla har undertecknat får du ett e-postmeddelande med en länk till det undertecknade dokumentet',
    SUCCESS_COMPLETION_SINGLE_SIGNER: 'Ett e-postmeddelande med en länk till det/de undertecknade dokumentet(en) har skickats till din e-post',
    FORM_SUCCESS_COMPLETION: 'Först när alla har undertecknat får du ett e-postmeddelande med en länk till det undertecknade formuläret',
    FORM_SUCCESS_COMPLETION_SINGLE_SIGNER: 'Ett e-postmeddelande med en länk till det undertecknade formuläret har skickats till din e-post',
    REFERENCE_ID: 'Referens-ID',
    LOGGED_OUT_MESSAGE: 'Du har blivit automatiskt utloggad och kan nu stänga detta fönster',
    ALL_SIGNERS: 'Alla undertecknare',
    ALL_SIGNERS_SINGLE_SIGNER: 'Undertecknare',
    DOWNLOAD_MESSAGE: 'Observera att du har 90 dagar på dig att ladda ner ditt exemplar av avtalsdokumentet. Allt du behöver göra är att följa länken i e-postmeddelandet vi har skickat till dig.',
    FORM_DOWNLOAD_MESSAGE: 'Observera att du har 90 dagar på dig att ladda ner ditt exemplar av formuläret. Allt du behöver göra är att följa länken i e-postmeddelandet vi har skickat till dig.',
    FILES_ORDER_DOWNLOAD_MESSAGE: ', som innehåller ett kvitto och en länk till dina filer.\nObservera att du har 90 dagar på dig att ladda ner din kopia av innehållet. Allt du behöver göra är att följa länken i e-postmeddelandet som skickades till dig.',
    FILES_ORDER_REJECTED_HEADING: 'Ordern har annullerats',
    FILES_ORDER_REJECTED_MESSAGE: 'Ett meddelande har skickats till avsändaren.',
    REJECTED_BY_OWNER_TITLE: 'Order avbruten av ägaren',
    REJECTED_BY_OWNER_MESSAGE: 'Denna order har avbrutits av ägaren.',
    REJECTED_BY_SIGNER_TITLE: 'Order avbruten - signatur avvisad',
    REJECTED_BY_SIGNER_MESSAGE: 'Denna order har avbrutits eftersom en av undertecknarna avvisade att signera.',
    NO_SIGNATURE_REQUIRED_HEADING: 'Succe',
    NO_SIGNATURE_REQUIRED_REJECTED_HEADING: 'Ordern har annullerats',
    NO_SIGNATURE_REQUIRED_MESSAGE: 'Ett e-postmeddelande har skickats till',
    NO_SIGNATURE_REQUIRED_REJECTED_MESSAGE: 'Ett meddelande har skickats till avsändaren.',
    NO_SIGNATURE_REQUIRED_MESSAGE_SUFFIX: ', det innehåller ett kvitto och en länk till avtalsdokumentet. Du har 90 dagar på dig att hämta din kopia av avtalet genom att följa länken i e-postmeddelandet.',
  },

  STATUS: {
    SIGNED: 'Signerad',
    RECEIVED: 'Mottaget',
    PENDING: 'Väntar',
    REJECTED: 'Avvisad',
    LOCKED: 'Låst',
  },

  NOT_FOUND: {
    TITLE: 'Sidan hittades inte',
    DESCRIPTION: 'Sidan du letar efter finns inte eller signeringslänken är ogiltig.',
  },

  NO_SUCH_APPROVER: {
    TITLE: 'Intern undertecknare inte igenkänd',
    DESCRIPTION: 'Inga interna undertecknare hittades som matchar det använda MitId.',
  },

  NO_ACCESS_CPR: {
    TITLE: 'CPR-kontrollen kunde inte genomföras',
    DESCRIPTION: 'Det använda MitID matchar inte det CPR-nummer som ska kontrolleras. Vänligen kontakta {{senderName}} och ange referensnr. {{referenceId}}.',
  },

  ARCHIVED: {
    TITLE: 'Signeringsordern är inte tillgänglig',
    DESCRIPTION: 'Den signeringsorder du försöker få åtkomst till är tyvärr inte längre tillgänglig. 90 dagar efter att den sista signatören har signerat raderas signaturordern och tillhörande dokument.',
  },

  ALREADY_SIGNED: {
    TITLE: 'Redan signerad',
    DESCRIPTION: 'Denna signeringsorder har redan signerats.',
  },

  CPR_ALREADY_SIGNED: {
    TITLE: 'CPR-order redan signerad',
    DESCRIPTION: 'Denna CPR-signeringsorder har redan slutförts.',
  },

  VERIFY_ERROR: {
    TITLE: 'Verifiering misslyckades',
    DESCRIPTION: 'Identiteten som användes för signering matchar inte den som krävs för denna order.',
  },

  ORDER_MISMATCH: {
    TITLE: 'Order stämmer inte överens',
    DESCRIPTION: 'Signeringsordern stämmer inte med den aktuella sessionen. Stäng andra flikar och försök igen.',
  },

  PSEUDONYM_DISALLOWED: {
    TITLE: 'Pseudonyma användare är inte tillåtna',
    DESCRIPTION: 'Kunden tillåter inte signering med en pseudonym identitet.',
  },

  EXPIRED: {
    TITLE: 'Tidsfristen för signeringsordern har löpt ut',
    DESCRIPTION: 'Avsändaren av denna signeringsorder - {{documentReference}} - har angett en tidsfrist för när signeringsordern senast kan undertecknas. Tidsfristen har nu löpt ut.',
    SUB_DESCRIPTION: 'Kontakta avsändaren {{senderName}} om du är osäker eller tror att ett fel har uppstått.',
    MORE_INFO: 'Klicka här för mer information',
    INFO_TITLE: 'Varför finns det en tidsfrist?',
    INFO: 'Alla signeringsordrar har en tidsfrist. På så sätt kan avsändaren säkerställa att signeringsordern undertecknas inom avsändarens valda kriterier.',
    SUB_TITLE: 'Vad gör jag nu?',
    SUB_INFO: 'Avsändaren har informerats om att en eller flera parter inte har undertecknat inom tidsfristen. Du kan antingen vänta på att avsändaren kontaktar dig, eller kontakta avsändaren på nytt.',
  },

  STEP_LOCKED: {
    TITLE: 'Det här steget är för närvarande låst',
    DESCRIPTION: 'Det här signeringssteget är låst och kan inte slutföras just nu. Kontakta avsändaren för mer information.',
  },

  UNEXPECTED: {
    TITLE: 'Ett oväntat fel uppstod',
    DESCRIPTION: 'Ett oväntat fel uppstod under behandlingen av din begäran. Försök igen senare.',
  },

  STEP_NOT_AVAILABLE: {
    TITLE: 'Det här steget är inte tillgängligt ännu',
    DESCRIPTION: 'Det här signeringssteget är inte tillgängligt ännu. Vänta tills föregående steg har slutförts innan du fortsätter.',
  },

  UNAUTHORIZED: {
    TITLE: 'Ett fel uppstod',
    DESCRIPTION: 'Vi kunde inte verifiera signeringssessionen. Försök igen via länken du har fått eller kontakta avsändaren.',
  },

  ERRORS: {
    UNAUTHORIZED: 'Du är inte behörig att komma åt denna resurs',
    BAD_REQUEST: 'Ogiltig begäran. Kontrollera dina inmatningar',
    FORBIDDEN: 'Åtkomst till denna resurs är förbjuden',
    NOT_FOUND: 'Den begärda resursen kunde inte hittas',
    SERVER_ERROR: 'Ett fel uppstod på servern. Försök igen senare',
    UNKNOWN_ERROR: 'Ett oväntat fel uppstod. Försök igen',
    SESSION_EXPIRED: 'Din session har löpt ut. Du omdirigeras till inloggning.',
  },

  RECEIPT_CPR: {
    SUCCESS_HEADING: 'Din identifiering har nu bekräftats.',
    SUCCESS_MESSAGE: 'Vi har skickat ett kvitto för din CPR-kontroll till',
    REJECTED_HEADING: 'Undertecknandet avvisades',
    REJECTED_MESSAGE: 'Ett meddelande har skickats till',
  },

  CPR_CHECK: {
    INSTRUCTION: 'Vänligen ange ditt CPR-nummer',
    CPR_NUMBER: 'CPR-nummer',
    CPR_NUMBER_PLACEHOLDER: 'Ange ditt personnummer',
    HEALTH_INSURANCE_CARD: 'Ladda upp ett foto av ditt sjukförsäkringskort',
    PHOTO_ID: 'Ladda upp en kopia av ditt foto-ID - t.ex. pass eller körkort',
    FILE_HINT: "Stödda format: 'png', 'jpg', 'bmp'. Max filstorlek: 10 MB.",
    PROTECTED_CPR_PHOTO_ID_REQUIRED: 'Eftersom du har skyddade personuppgifter kan vi inte verifiera dina uppgifter. Vänligen fyll i fälten nedan.',
  },

  REJECT_MODAL: {
    TITLE: 'Vill du avvisa den här ordern?',
    REASON_PLACEHOLDER: 'Skriv din anledning till avvisning',
    CONFIRM: 'Bekräfta avvisning',
  },

  DOWNLOAD_STEP: {
    HEADING: 'Ladda ner dina dokument',
    DESCRIPTION: 'Du kan nu ladda ner en kopia av dina signerade dokument. Dokumenten är tillgängliga i 90 dagar från det datum de signerades. Klicka på ladda knappen för att spara dem lokalt på din dator.',
    DOWNLOAD_BUTTON: 'Ladda ner kopia',
    LOGOUT_BUTTON: 'Logga ut',
    LOGGED_OUT_HEADING: 'Du har loggats ut',
    LOGGED_OUT_DESCRIPTION: 'Tack för att du använder Esignatur. Vi ser fram emot att se dig igen.',
  },

  LOGOUT_MODAL: {
    TITLE: 'Logga ut?',
    DESCRIPTION: 'Är du säker på att du vill logga ut? Eventuella ändringar kommer att gå förlorade.',
    CONFIRM: 'Logga ut',
  },

  REJECTION_SUCCESS_MODAL: {
    TITLE: 'Ordern avvisades',
    DESCRIPTION: 'Den här ordern har avvisats',
    CONTINUE: 'Fortsätt',
  },

  APPROVER_RECEIPT: {
    SUCCESS_HEADING: 'Dina signaturer slutfördes framgångsrikt.',
    SUCCESS_MESSAGE: 'Du har automatiskt loggats ut och kan nu stänga det här fönstret.',
  },

  SUPPORT: {
    CONTACT: 'Kontakta oss via e-post:',
  },
};
